import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { get, post } from "../../../components/Utils/CallApi";
import { setError } from "../appSlice";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async ({ companyId }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `companyId=${companyId}`;
      const response = await get("user/list", params);

      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveUser = createAsyncThunk(
  "users/saveUser",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const response = await post("user/save", payload);

      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    usersList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.usersList = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUser.fulfilled, (state, action) => {
        state.loading = false;
        state.usersList.push(action.payload);
      })
      .addCase(saveUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default usersSlice.reducer;
